module.exports = __webpack_public_path__ + "static/media/Stellar Single Bed Base - 120x200 cm_Natural.2e4475c4.png";